import _jsx from '@babel/runtime/helpers/jsx';
import _objectSpread from '@babel/runtime/helpers/objectSpread2';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React, { useRef, useEffect, useState } from 'react';
import 'prop-types';
import { Tabs, Tab, TabContent } from '@andes/tabs';
import { namespaceComparator } from '@recommendations-fe/commons/namespaces';
import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/es.array.sort.js';
import 'core-js/modules/web.dom-collections.iterator.js';
import { useIntersectionObserver, mapPropsToQuery, TrackService, useTrackOnPrint, getFormattedIntFraction, getFormattedDecimalFraction, useTrackOnView } from '@recommendations-fe/commons';
import 'core-js/modules/es.regexp.exec.js';
import 'core-js/modules/es.string.trim.js';
import frontendRestclient from 'frontend-restclient';
import 'core-js/modules/es.array.includes.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { TableHead, TableHeader, TableBody, TableRow, TableData, Table } from '@andes/table';
import { Image } from 'frontend-image';
import MoneyAmount from '@andes/money-amount';
import classnames from 'classnames';
import { Button, ButtonText } from '@andes/button';
const sites = {
  MLA: {
    url: {
      mainDomain: 'mercadolibre.com.ar',
      baseDomain: '//www.mercadolibre.com.ar'
    }
  },
  MPE: {
    url: {
      mainDomain: 'mercadolibre.com.pe',
      baseDomain: '//www.mercadolibre.com.pe'
    }
  },
  MPT: {
    url: {
      mainDomain: 'mercadolivre.pt',
      baseDomain: '//www.mercadolivre.pt'
    }
  },
  MRD: {
    url: {
      mainDomain: 'mercadolibre.com.do',
      baseDomain: '//www.mercadolibre.com.do'
    }
  },
  MPA: {
    url: {
      mainDomain: 'mercadolibre.com.pa',
      baseDomain: '//www.mercadolibre.com.pa'
    }
  },
  MEC: {
    url: {
      mainDomain: 'mercadolibre.com.ec',
      baseDomain: '//www.mercadolibre.com.ec'
    }
  },
  MCR: {
    url: {
      mainDomain: 'mercadolibre.co.cr',
      baseDomain: '//www.mercadolibre.co.cr'
    }
  },
  MLU: {
    url: {
      mainDomain: 'mercadolibre.com.uy',
      baseDomain: '//www.mercadolibre.com.uy'
    }
  },
  MLM: {
    url: {
      mainDomain: 'mercadolibre.com.mx',
      baseDomain: '//www.mercadolibre.com.mx'
    }
  },
  MLC: {
    url: {
      mainDomain: 'mercadolibre.cl',
      baseDomain: '//www.mercadolibre.cl'
    }
  },
  MCO: {
    url: {
      mainDomain: 'mercadolibre.com.co',
      baseDomain: '//www.mercadolibre.com.co'
    }
  },
  MLV: {
    url: {
      mainDomain: 'mercadolibre.com.ve',
      baseDomain: '//www.mercadolibre.com.ve'
    }
  },
  MLB: {
    url: {
      mainDomain: 'mercadolivre.com.br',
      baseDomain: '//www.mercadolivre.com.br'
    }
  },
  MBO: {
    url: {
      mainDomain: 'mercadolibre.com.bo',
      baseDomain: '//www.mercadolibre.com.bo'
    }
  },
  MPY: {
    url: {
      mainDomain: 'mercadolibre.com.py',
      baseDomain: '//www.mercadolibre.com.py'
    }
  },
  MGT: {
    url: {
      mainDomain: 'mercadolibre.com.gt',
      baseDomain: '//www.mercadolibre.com.gt'
    }
  },
  MHN: {
    url: {
      mainDomain: 'mercadolibre.com.hn',
      baseDomain: '//www.mercadolibre.com.hn'
    }
  },
  MNI: {
    url: {
      mainDomain: 'mercadolibre.com.ni',
      baseDomain: '//www.mercadolibre.com.ni'
    }
  },
  MSV: {
    url: {
      mainDomain: 'mercadolibre.com.sv',
      baseDomain: '//www.mercadolibre.com.sv'
    }
  },
  MCU: {
    url: {
      mainDomain: 'mercadolibre.com.cu',
      baseDomain: '//www.mercadolibre.com.cu'
    }
  }
};
var config = sites;
const env = process.env.NODE_ENV;
const url = env !== 'development' ? 'https://www.mercadolibre.com.ar' : 'http://api.internal.ml.com';
const restClientConfig = {
  timeout: 30000,
  baseURL: url,
  withCredentials: true,
  sendCSRFToken: false
};
const restclient = frontendRestclient(restClientConfig);
const API_PATH = '/product-fe-recommendations/recommendations';
const defaultHeaders = {
  'x-card-type': 'web',
  'x-recosplugin-version': '###VERSION###'
};
class RecommendationsService {
  static getHostname(params) {
    return "https:".concat(config[params.site_id].url.baseDomain);
  }
  static fetchRecommendations(params, headers) {
    const requestHeaders = _objectSpread(_objectSpread({}, defaultHeaders), headers);

    // https://github.com/bfred-it/supports-webp/blob/master/dist/supports-webp.min.js
    // eslint-disable-next-line
    //const supportsWebP = (function () {'use strict';return new Promise(function (A) {var n = new Image();(n.onerror = function () {return A(!1);}),(n.onload = function () {return A(1 === n.width);}),(n.src = 'data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoBAAEAAwA0JaQAA3AA/vuUAAA=');}).catch(function () {return !1;});})();

    requestHeaders['x-image-webp'] = true;
    return restclient.get(API_PATH, {
      params,
      headers: requestHeaders,
      baseURL: this.getHostname(params)
    }).then(response => response.data).catch(() => {});
  }
  static getLab() {
    let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let lab;
    try {
      if (props.env) {
        lab = props.env;
      } else if (document && document.cookie) {
        // eslint-disable-next-line no-undef
        const meliLabCookie = document.cookie.split(';').find(s => s.split('=')[0].trim() === 'meliLab');
        if (meliLabCookie) {
          const currentLab = meliLabCookie.split('=')[1].trim();
          if (currentLab === 'recosreact') {
            lab = 'test0';
          } else if (currentLab === 'recos') {
            lab = 'test';
          } else if (currentLab === 'release') {
            lab = 'testrelease';
          } else if (currentLab.match(/recos-([0-9]*)/)) {
            lab = "test".concat(currentLab.split('-')[1]);
          }
        }
      }
    } catch (error) {
      if (console) {
        // eslint-disable-next-line no-console
        console.info('Recommendations - Cannot get lab info.', error);
      }
    }
    return lab;
  }
}
var RecommendationsService$1 = RecommendationsService;
const useRecommendationsComparator = _ref => {
  let {
    props,
    componentRef,
    fetchDelay = 0
  } = _ref;
  // Set & Sync the visibility status of the comparator w/ IO hook
  const isComparatorOnViewport = useRef(false);
  const {
    isOnViewport,
    setIsOnViewport,
    observeElement
  } = useIntersectionObserver({
    externalRef: componentRef,
    once: true,
    startOff: true
  });
  useEffect(() => {
    isComparatorOnViewport.current = isOnViewport;
  }, [isOnViewport]);

  // Set the fetched recommendations status of the comparator
  const [fetchedRecommendations, setFetchedRecommendations] = useState([]);

  // Update the fetched recommendations when productId (or another -prop- dependency) changes
  // disable lint - depende solo del ID
  useEffect(() => {
    // Fetch recos for each client and update recos if isn't on the viewport
    // or if is on the viewport without any recommendation
    const getRecommendations = _ref2 => {
      let {
        clients
      } = _ref2;
      const query = _objectSpread({
        site_id: props.siteId,
        product_id: props.productId,
        item_id: props.itemId,
        tracking: true,
        product_details: true,
        env: RecommendationsService$1.getLab(props)
      }, mapPropsToQuery({
        componentProps: props,
        paramsToMap: ['pdp_filters']
      }));

      // Clean prev recos (to load new recos if the item changes and enters the viewport before request response)
      setFetchedRecommendations([]);
      clients.forEach((client, index) => {
        RecommendationsService$1.fetchRecommendations(_objectSpread(_objectSpread({}, query), {}, {
          client
        })).then(response => {
          // Timeout for Storybook test
          setTimeout(() => {
            setFetchedRecommendations(prevRecos => {
              // Reset the visibility status to false (cos IO has once:true for performance)
              setIsOnViewport(false);
              // Observe the element again (cos IO has once:true & startOff:true for performance)
              observeElement({
                element: componentRef.current
              });
              const updatedRecos = [...prevRecos];

              // If already has recos and is on viewport, ignore the request
              // Dont update the recos (cos we dont want reprint the tabs)
              if (prevRecos.length > 0 && isComparatorOnViewport.current) {
                TrackService.requestIgnored(client);
              } else {
                // eslint-disable-next-line security/detect-object-injection
                updatedRecos[index] = response;
              }
              return updatedRecos;
            });
          }, fetchDelay);
        }).catch(() => {});
      });
    };

    // Update recos with ssr or service
    if (props.apiResponse) {
      setFetchedRecommendations(props.apiResponse.recommendations);
    } else {
      getRecommendations({
        clients: props.clients
      });
    }
  }, [props.productId]); // eslint-disable-line react-hooks/exhaustive-deps

  // Set the enhanced (filtered and sorted) recommendations
  const [enhancedRecommendations, setEnhancedRecommendations] = useState([]);

  // Filter and sort when the fetched recommendations changes
  useEffect(() => {
    if (fetchedRecommendations && fetchedRecommendations.length > 0) {
      const filteredRecos = fetchedRecommendations.filter(reco => {
        var _reco$recommended_pro;
        return reco && reco.attributes_list && ((_reco$recommended_pro = reco.recommended_products) === null || _reco$recommended_pro === void 0 ? void 0 : _reco$recommended_pro.length) > 0;
      });
      if (!filteredRecos || filteredRecos.length <= 0) {
        return;
      }
      const sortedRecos = filteredRecos.sort((a, b) => a.priority - b.priority);
      setEnhancedRecommendations(sortedRecos);
    }
  }, [fetchedRecommendations]);
  return {
    recommendations: enhancedRecommendations
  };
};
var useRecommendationsComparator$1 = useRecommendationsComparator;
const useTrackComparator = function () {
  let {
    productId,
    recommendations
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // Set the tracked clients + Get a callback for PRINT tracking
  const [trackedOnViewClients, setTrackedOnViewClients] = useState([]);
  const [trackedOnPrintClients, setTrackedOnPrintClients] = useState([]);
  const {
    trackOnPrint
  } = useTrackOnPrint();

  // Reset the tracked clients when ID changes
  // disable lint - depende solo del ID
  useEffect(() => {
    setTrackedOnPrintClients([]);
    setTrackedOnViewClients([]);
  }, [productId]); // eslint-disable-line react-hooks/exhaustive-deps

  // Try to track the print of the recommendations when they change
  // disable lint - depende solo de las recomendaciones
  useEffect(() => {
    if (recommendations && recommendations.length > 0) {
      recommendations.forEach(reco => {
        const {
          client
        } = reco;
        const alreadyTracked = trackedOnPrintClients.includes(client);
        if (!alreadyTracked) {
          trackOnPrint(reco.tracking);
          setTrackedOnPrintClients([...trackedOnPrintClients, client]);
        }
      });
    }
  }, [recommendations]); // eslint-disable-line react-hooks/exhaustive-deps

  return {
    trackedOnViewClients,
    setTrackedOnViewClients,
    trackedOnPrintClients,
    setTrackedOnPrintClients
  };
};
var useTrackComparator$1 = useTrackComparator;
const _excluded = ["productId", "env", "apiResponse", "fetchDelay", "runCatchErrorBoundary"];
const withComparatorContainer = WrappedComparator => {
  const ComparatorContainer = _ref => {
    let {
        productId,
        env = null,
        apiResponse = null,
        fetchDelay = 0,
        runCatchErrorBoundary = () => {}
      } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded);
    try {
      // Make a comparator ref for IO : for the useRecommendations hook
      const comparatorContainerRef = useRef();

      // Get (filtered & sorted) recommendations when item changes (with ssr or service)
      const {
        recommendations
      } = useRecommendationsComparator$1({
        props: _objectSpread({
          productId,
          env,
          apiResponse
        }, rest),
        componentRef: comparatorContainerRef,
        fetchDelay
      });
      const {
        IconFactory
      } = rest;

      // Tracks when the recommendation is printed and sets the tracked on view clients
      const {
        trackedOnViewClients,
        setTrackedOnViewClients
      } = useTrackComparator$1({
        productId,
        recommendations
      });

      // Handle the tab scroll (for mobile)
      const wrappedComparatorRef = useRef();
      const tabClicked = tabRef => {
        if (tabRef && tabRef.current) {
          tabRef.current.scrollLeft = 0;
        }
      };
      return /*#__PURE__*/jsx("section", {
        ref: comparatorContainerRef,
        className: "".concat(namespaceComparator, "__wrapper-ref"),
        children: recommendations.length > 0 && /*#__PURE__*/jsxs(Fragment, {
          children: [/*#__PURE__*/_jsx("h2", {
            className: "".concat(namespaceComparator, "__title")
          }, void 0, recommendations[0].title), recommendations.length === 1 ? /*#__PURE__*/_jsx(WrappedComparator, {
            recommendations: recommendations[0],
            productId: productId,
            trackedOnViewClients: trackedOnViewClients,
            setTrackedOnViewClients: setTrackedOnViewClients,
            IconFactory: IconFactory
          }) : /*#__PURE__*/_jsx(Tabs, {}, void 0, recommendations.map(reco => /*#__PURE__*/_jsx(Tab, {
            title: reco.labels.tab,
            onClick: () => tabClicked(wrappedComparatorRef)
          }, reco.priority.toString(), /*#__PURE__*/_jsx(TabContent, {}, void 0, /*#__PURE__*/jsx(WrappedComparator, {
            recommendations: reco,
            productId: productId,
            trackedOnViewClients: trackedOnViewClients,
            setTrackedOnViewClients: setTrackedOnViewClients,
            ref: wrappedComparatorRef,
            IconFactory: IconFactory
          })))))]
        })
      });
    } catch (error) {
      return runCatchErrorBoundary(error);
    }
  };

  // Set a display name for the wrapper component
  ComparatorContainer.displayName = "\n  Comparator Container - ".concat(WrappedComparator.displayName || WrappedComparator.name || 'WrappedComparator', "\n  ");
  return ComparatorContainer;
};
var withComparatorContainer$1 = withComparatorContainer;
var _div;
const ComparatorTableHead = _ref => {
  let {
    products,
    labels
  } = _ref;
  const namespace = "".concat(namespaceComparator, "__table");
  return /*#__PURE__*/_jsx(TableHead, {}, void 0, /*#__PURE__*/_jsx(TableHeader, {
    scope: "column",
    className: "".concat(namespace, "__header")
  }, void 0, _div || (_div = /*#__PURE__*/_jsx("div", {}))), products.map((product, index) => /*#__PURE__*/_jsx(TableHeader, {
    scope: "column",
    align: "center",
    className: "".concat(namespace, "__header")
  }, product.id, index === 0 ? /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx("div", {}, void 0, /*#__PURE__*/_jsx(Image, {
      className: "".concat(namespace, "__header__image"),
      src: product.img_url,
      alt: product.name
    }), /*#__PURE__*/_jsx("p", {
      className: "".concat(namespace, "__header__title")
    }, void 0, product.name)), /*#__PURE__*/_jsx("span", {
      className: "".concat(namespace, "__header__link__text no-action")
    }, void 0, labels.this_product)]
  }) : /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx("a", {
      href: product.permalink,
      className: "".concat(namespace, "__header__link")
    }, void 0, /*#__PURE__*/_jsx(Image, {
      className: "".concat(namespace, "__header__image"),
      src: product.img_url,
      alt: product.name
    }), /*#__PURE__*/_jsx("p", {
      className: "".concat(namespace, "__header__title")
    }, void 0, product.name)), /*#__PURE__*/_jsx("a", {
      href: product.permalink,
      className: "".concat(namespace, "__header__link__text")
    }, void 0, labels.see_product)]
  }))));
};
var ComparatorTableHead$1 = ComparatorTableHead;
const RECOMMENDATIONS_CHEVRON = 'recommendations-chevron';
const RECOMMENDATIONS_START_EMPTY = 'recommendations-star-empty';
const RECOMMENDATIONS_START_HALF = 'recommendations-star-half';
const RECOMMENDATIONS_START_FULL = 'recommendations-star-full';
const namespace$2 = "".concat(namespaceComparator, "__reviews");
const REVIEW_MAX_STARS = 5;
const Reviews = _ref => {
  let {
    amount,
    rating,
    IconFactory,
    stars
  } = _ref;
  const IconStarEmpty = IconFactory(RECOMMENDATIONS_START_EMPTY, "".concat(namespaceComparator, "__icon"));
  const IconStarHalf = IconFactory(RECOMMENDATIONS_START_HALF, "".concat(namespaceComparator, "__icon"));
  const IconStarFull = IconFactory(RECOMMENDATIONS_START_FULL, "".concat(namespaceComparator, "__icon"));
  const starsToPrint = stars !== null && stars !== void 0 ? stars : rating;
  const full = Math.floor(starsToPrint);
  const half = Math.ceil(starsToPrint - full);
  const empty = REVIEW_MAX_STARS - half - full;
  const ratings = [];
  for (let f = 0; f < full; f += 1) {
    ratings.push(IconStarFull);
  }
  for (let h = 0; h < half; h += 1) {
    ratings.push(IconStarHalf);
  }
  for (let e = 0; e < empty; e += 1) {
    ratings.push(IconStarEmpty);
  }
  return /*#__PURE__*/_jsx("div", {
    className: "".concat(namespace$2, "__label")
  }, void 0, rating ? /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx("span", {
      className: "".concat(namespace$2, "__rating")
    }, void 0, rating.toFixed(1)), /*#__PURE__*/_jsx("span", {
      className: "".concat(namespace$2, "__ratings")
    }, void 0, ratings), /*#__PURE__*/_jsx("span", {
      className: "".concat(namespace$2, "__amount")
    }, void 0, "(", "".concat(amount), ")")]
  }) : /*#__PURE__*/_jsx("span", {
    className: "".concat(namespace$2, "__no-rating")
  }, void 0, "_"));
};
var Reviews$1 = Reviews;
const namespace$1 = "".concat(namespaceComparator, "__seller-info");
const SellerInfo = _ref => {
  let {
    sellerInfo
  } = _ref;
  return sellerInfo.link ? /*#__PURE__*/_jsx("a", {
    href: sellerInfo.link,
    title: sellerInfo.name,
    className: namespace$1
  }, void 0, sellerInfo.name) : /*#__PURE__*/_jsx("span", {}, void 0, sellerInfo.name);
};
var SellerInfo$1 = SellerInfo;
const namespace = "".concat(namespaceComparator, "__price");
const Price = _ref => {
  let {
    thousandSeparator,
    decimalSeparator,
    currencySymbol,
    value,
    isMobile
  } = _ref;
  const intFraction = getFormattedIntFraction(value, thousandSeparator);
  const decimalFraction = getFormattedDecimalFraction(value);
  const centsSeparator = decimalSeparator === ',' ? 'comma' : 'dot';
  return /*#__PURE__*/_jsx(MoneyAmount, {
    value: {
      fraction: intFraction,
      cents: decimalFraction
    },
    symbol: currencySymbol,
    className: namespace,
    size: isMobile ? 12 : 14,
    centsType: centsSeparator
  });
};
var Price$1 = Price;
const ComparatorTableContent = _ref => {
  let {
    attribute,
    component,
    isMobile,
    IconFactory
  } = _ref;
  if (component === undefined) {
    return /*#__PURE__*/_jsx("div", {
      className: "".concat(namespaceComparator, "--no-attr")
    });
  }
  switch (attribute) {
    case 'REVIEWS':
      if (component.rating_average > 5) {
        component.rating_average = 5;
      }
      return /*#__PURE__*/_jsx(Reviews$1, {
        rating: component.rating_average,
        amount: component.count_reviews,
        IconFactory: IconFactory,
        stars: component.stars
      });
    case 'SELLER':
      return /*#__PURE__*/_jsx(SellerInfo$1, {
        sellerInfo: component
      });
    case 'PRICE':
      return /*#__PURE__*/_jsx(Price$1, {
        decimalSeparator: component.decimal_separator,
        thousandSeparator: component.thousand_separator,
        currencySymbol: component.currency_symbol,
        value: component.value,
        isMobile: isMobile
      });
    default:
      return /*#__PURE__*/_jsx("span", {}, void 0, component.text);
  }
};
var ComparatorTableContent$1 = ComparatorTableContent;
const ComparatorTableBody = _ref => {
  let {
    products,
    attributes,
    isMobile,
    IconFactory
  } = _ref;
  const namespace = "".concat(namespaceComparator, "__table");
  return /*#__PURE__*/_jsx(TableBody, {}, void 0, attributes.map(attribute => /*#__PURE__*/_jsx(TableRow, {}, attribute.id, /*#__PURE__*/_jsx(TableHeader, {
    scope: "row",
    className: "".concat(namespace, "__body__column")
  }, attribute.id, attribute.title), products.map(product => /*#__PURE__*/_jsx(TableData, {
    className: "".concat(namespace, "__body__column")
  }, product.id, /*#__PURE__*/_jsx(ComparatorTableContent$1, {
    attribute: attribute.id,
    component: product.product_details[attribute.id],
    isMobile: isMobile,
    IconFactory: IconFactory
  }))))));
};
var ComparatorTableBody$1 = ComparatorTableBody;
const ComparatorTable = _ref => {
  let {
    recommendations,
    isMobile = false,
    IconFactory
  } = _ref;
  const namespace = "".concat(namespaceComparator, "__table");
  const tableProps = {
    products: recommendations.recommended_products,
    attributes: recommendations.attributes_list,
    labels: recommendations.labels,
    isMobile,
    IconFactory
  };
  if (recommendations && recommendations.attributes_list && recommendations.recommended_products) {
    return /*#__PURE__*/_jsx(Table, {
      className: namespace
    }, void 0, ComparatorTableHead$1(tableProps), ComparatorTableBody$1(tableProps));
  }
  return null;
};
var ComparatorTable$1 = ComparatorTable;
const ComparatorDesktop = _ref => {
  let {
    recommendations,
    trackedOnViewClients = [],
    setTrackedOnViewClients = null,
    IconFactory
  } = _ref;
  // Make a desktop comparator ref for IO
  const desktopComparatorRef = useRef();

  // TRACK ON VIEW => Automatic track when is on the viewport
  useTrackOnView({
    componentRef: desktopComparatorRef,
    trackData: recommendations.tracking,
    client: recommendations.client,
    trackedOnViewClients,
    setTrackedOnViewClients,
    shouldTrackOnView: true
  });
  return /*#__PURE__*/jsx("section", {
    id: recommendations.client,
    ref: desktopComparatorRef,
    className: namespaceComparator,
    children: /*#__PURE__*/_jsx(ComparatorTable$1, {
      recommendations: recommendations,
      IconFactory: IconFactory
    })
  });
};
var ComparatorDesktop$1 = ComparatorDesktop;
const withCollapsibleTable = WrappedTable => {
  const CollapsibleTable = /*#__PURE__*/React.forwardRef((_ref, ref) => {
    let {
      recommendations,
      IconFactory
    } = _ref;
    // Set a collapsed status for the table
    const [collapsed, setCollapsed] = useState(true);

    // Set Classnames
    const namespace = "".concat(namespaceComparator, "__table");
    const withTwoRecos = recommendations.recommended_products.length === 2;
    return /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx("div", {
        className: classnames("".concat(namespace, "__shadow-container"), collapsed && 'collapsed')
      }, void 0, /*#__PURE__*/jsx("div", {
        className: classnames("".concat(namespace, "__container"), withTwoRecos && 'two-cols'),
        ref: ref,
        children: /*#__PURE__*/_jsx(WrappedTable, {
          recommendations: recommendations,
          IconFactory: IconFactory,
          isMobile: true
        })
      })), collapsed && /*#__PURE__*/_jsx(Button, {
        className: "table-button",
        hierarchy: "transparent",
        size: "small",
        onClick: () => {
          setCollapsed(false);
          TrackService.clickMore(recommendations.tracking);
        }
      }, void 0, /*#__PURE__*/_jsx(ButtonText, {}, void 0, recommendations.labels.more_details), IconFactory(RECOMMENDATIONS_CHEVRON, "".concat(namespaceComparator, "__icon chevron-down")))]
    });
  });

  // Set a display name for the wrapper component
  CollapsibleTable.displayName = "\n  Collapsible Table - ".concat(WrappedTable.displayName || WrappedTable.name || 'WrappedTable', "\n  ");
  return CollapsibleTable;
};
var withCollapsibleTable$1 = withCollapsibleTable;

// React
const ComparatorTableMobile = withCollapsibleTable$1(ComparatorTable$1);

// Forward the ref for scrollLeft
const ComparatorMobile = /*#__PURE__*/React.forwardRef((_ref, forwardedRef) => {
  let {
    recommendations,
    trackedOnViewClients = [],
    setTrackedOnViewClients = null,
    IconFactory
  } = _ref;
  // Make a mobile comparator ref for IO
  const mobileComparatorRef = useRef();

  // TRACK ON VIEW => Automatic track when is on the viewport
  useTrackOnView({
    componentRef: mobileComparatorRef,
    trackData: recommendations.tracking,
    client: recommendations.client,
    trackedOnViewClients,
    setTrackedOnViewClients,
    shouldTrackOnView: true
  });
  return /*#__PURE__*/jsx("section", {
    id: recommendations.client,
    ref: mobileComparatorRef,
    className: namespaceComparator,
    children: /*#__PURE__*/jsx(ComparatorTableMobile, {
      recommendations: recommendations,
      ref: forwardedRef,
      IconFactory: IconFactory
    })
  });
});
var ComparatorMobile$1 = ComparatorMobile;

// Components
const RecommendationsComparatorDesktop = withComparatorContainer$1(ComparatorDesktop$1);
const RecommendationsComparatorMobile = withComparatorContainer$1(ComparatorMobile$1);
export { RecommendationsComparatorDesktop, RecommendationsComparatorMobile };
